import { useEffect } from 'react';

// useMount runs fn once, after the component's first render — the explicit,
// greppable form of `useEffect(fn, [])` for "load initial data / kick off a
// one-time subscription". Callers don't need an
// `// eslint-disable-next-line react-hooks/exhaustive-deps`: the
// react-hooks/exhaustive-deps rule only tracks the built-in hooks, not custom
// wrappers, so the intent ("mount only, on purpose") stays visible instead of
// hidden behind a disable comment.
//
// Use a real dependency array (plain useEffect) whenever the effect should
// re-run — this hook is strictly for the run-exactly-once case.
export function useMount(fn) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fn(); }, []);
}
